//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MasterMenu from '@master/mg-menu/packages/menu/index.vue';
import { openLogin } from '@/utils/sso';
import { setting_obj } from '~/settings/setting';
import { formatPath, toMasterLogin } from '@/utils/tools';
import { user_controller } from '@/api/controller/users';
import { isMobile, isElectron, isTikTok } from '@/utils/constants';
import { clearRecordNum } from '@/components/subscription/subscription';

export default {
  name: 'TopBar',
  components: {
    MasterMenu,
  },
  props: {
    listMode: {
      type: Object,
    },
  },
  data() {
    return {
      showBorder: false,
      sensors: this.$sensors,
      isTikTok: false,
      isClient: false,
      showMenu: true,
      debugAvatar: '',
    };
  },
  created() {
    if (process.server) {
      // 服务端根据 HTTP 请求头判断是否来自 Electron，为了解决头部空白跳动的问题
      const ua = this.$ssrContext.req.headers['user-agent'];
      this.isClient = isElectron(ua);
    }
  },
  computed: {
    showGuide() {
      return this.$store.state.user.showHeadGuide;
    },
    userInfo() {
      const { avatar } = this.$store.state.user.userInfo;
      const _avatar = this.debugAvatar || avatar;
      const path = formatPath(_avatar, setting_obj.imageCdnPath);
      return { ...this.$store.state.user.userInfo, avatar: path };
    },
    colorMode() {
      return this.$store.state.user.colorMode;
    },
    headType() {
      return isMobile() ? 'default' : 'withButton';
    },
    expandList() {
      return [
        {
          title: '我的收藏',
          enabled: true,
          type: 'router',
          path: '/community/profile/id?tab=save',
          appendIndex: (item) => item.type === 'theme',
          icon: 'starIcon',
        },
      ];
    },
  },
  mounted() {
    this.debugAvatar = localStorage.getItem('debugAvatar');
    // 这里还需要在客户端进行判断，因为 data 中的 isClient 默认为 false
    this.isClient = isElectron();
    window.addEventListener('scroll', this.scrollEvent);
    this.isTikTok = isTikTok();
    const reg = /(\/search|resource\/[\d+]|plugin\/[\d+]|tag\/|activity\/detail|resource\?\S*?\d+|\/profile\/[\d+])/gi;
    // 客户端不展示menu的路由 /search resource/[\d+] plugin/[\d+] tag/ activity/detail resource?\S*?\d+ /profile/[\d+]
    this.showMenu = (!reg.test(location.href) && this.isClient) || !this.isClient;
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollEvent);
  },
  methods: {
    closeGuide() {
      this.$store.dispatch('user/handleHeadGuide', 0);
    },
    toMasterLogin,
    beforeToHome() {
      sessionStorage.from = 'master';
    },
    jump(data) {
      let { path } = data;
      const code = data.code || '';
      if (code.indexOf('community') === 0 && path) {
        // 如果当前点击为社区相关页面走router方式跳转
        const origin = location.origin;
        path = path.split(`${origin}/community`)[1] || '/';
        this.$router.push({
          path,
        });
      } else if (path) {
        sessionStorage.from = 'master';
        path = formatPath(path, '');
        window.open(path, '_blank', 'noopener,noreferrer');
      }
    },
    scrollEvent() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      this.showBorder = scrollTop > 0;
    },
    goHome() {
      this.$router.push({ path: '/' });
    },
    topath(params) {
      if (params.path.indexOf('/community/profile/id') !== -1) {
        const href = params.path;
        window.open(href.replace('/id', `/${this.userInfo.id}`));
        this.setProfileSensors();
      } else {
        if (params.path === '/files/home' && isElectron()) {
          window.location.href = params.path;
          return;
        }
        window.open(params.path);
      }
    },
    changeTheme(params) {
      this.$store.commit('user/setColor', params.value);
      user_controller.put_settings(this.$axios, { color_schema: params.value });
    },
    logout() {
      const login_obj = require('@master/mg-omni');
      login_obj.plugin
        .logout()
        .then(() => {
          if (process.client && window.navigator.userAgent.indexOf('MicroMessenger') > -1) {
            // 防止微信浏览器退出登录以后，点击登录进行静默授权
            window.sessionStorage.setItem('WEI_XIN_SNSAPI_BASE_DONE', '1');
          }
          clearRecordNum();
          window.location.reload();
        })
        .finally(() => {});
    },
    login(type) {
      openLogin(type);
    },
    setProfileSensors() {
      this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter1: 'menu',
        action_parameter2: 'profile',
      });
    },
  },
};
